import type { PageRecord, Store } from '@nexus/store';
import { applyTemplate, dailyTemplate, ensureSpecialPage } from '@nexus/workspace';

export const DAILY_PARENT = 'Dagnotities';

export function todayTitle(now = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Open today's daily note (YYYY-MM-DD under "Dagnotities"), creating it from the template if needed. */
export async function ensureDailyNote(
  store: Store,
  locale: string,
  now = new Date(),
): Promise<PageRecord> {
  const folder = await ensureSpecialPage(store, 'daily_parent_id', DAILY_PARENT, '📅');
  const title = todayTitle(now);
  const existing = (await store.listPages()).find(
    (p) => p.parentId === folder.id && p.title === title,
  );
  if (existing) return existing;
  const template = await dailyTemplate(store);
  if (template)
    return applyTemplate(store, template.page.id, {
      title,
      locale,
      now,
      targetId: folder.id,
      exactTitle: true,
    });
  const page = await store.createPage({ title, parentId: folder.id });
  await store.setProp(page.id, 'type', 'daily');
  return page;
}
